export default __webpack_public_path__ + "static/media/CivilEng_Icon-05.fb8f92fa.png";